module.exports = __webpack_public_path__ + "img/Kreis_min.f553f6d6.png";